<ng-container *ngIf="bannerData$ | async as data">
  <ngb-carousel *ngIf="data" [interval]="this.intervalTime">
    <ng-template ngbSlide *ngFor="let slide of data">
      <div [ngClass]="activeCountry$ | async">
        <cx-media *ngIf="slide.media" [container]="(slide?.media)['desktop']" class="responsive-desktop"></cx-media>
        <cx-media *ngIf="slide.media" [container]="(slide?.media)['tablet']" class="responsive-tablet"></cx-media>
        <cx-media
          *ngIf="slide.media"
          [container]="(slide?.media)['mobile']"
          class="responsive-mobile"
          (click)="redirectTo(slide.urlLink)"
        ></cx-media>
      </div>
      <div class="carousel-caption">
        <ng-container
          *ngIf="
            ((slide.title | json) !== '{}' && slide.title !== null && !!slide.title) ||
            ((slide.title | json) !== '{}' && slide.description !== null && !!slide.description) ||
            ((slide.urlLink | json) !== '{}' && slide.urlLink !== null && !!slide.urlLink)
          "
        >
          <div class="banner-texts">
            <h3 *ngIf="(slide.title | json) !== '{}'">{{ slide.title }}</h3>
            <p *ngIf="(slide.description | json) !== '{}'" class="d-none d-md-block">{{ slide.description }}</p>
            <ng-container *ngIf="checkUrl(slide.urlLink)">
              <button mat-flat-button class="primary-btn d-none d-md-block" (click)="redirectTo(slide.urlLink)">
                {{ 'banner.goTo' | cxTranslate }} {{ slide.title | uppercase }}
              </button>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </ngb-carousel>
</ng-container>
